import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
const apiUri = "/api/v2/dana/isPoNumberDuplicate";

export interface RequestPoNumberApi extends ApiParameter {
    customerPo?: string,
    soldToNumber?: string,
    dd?: number;
}

export interface IsPoNumberDuplicateResult extends BaseModel {
     isPoNumberDuplicate:boolean;
}

export async function isPoNumberDuplicate(parameter: RequestPoNumberApi) {
    const result = await get<IsPoNumberDuplicateResult>(`${apiUri}`, parameter);
    return result;    
}